// https://vuex.vuejs.org/en/state.html

export default {
  messages: {
    success: '',
    error: [],
    warning: '',
    validation: [],
  },
  fetching: false,
  officeTokenValidity:()=>{
    var v = localStorage.getItem('officeTokenValidity');
    if(!v) return '';
    try { var decoded = atob(v); return decoded=='' ? '' : JSON.parse(decoded); } catch(e){ return ''; }
  },
  exchangeEwsValidity:()=>{
    var v = localStorage.getItem('exchangeEwsValidity');
    if(!v) return '';
    try { var decoded = atob(v); return decoded=='' ? '' : JSON.parse(decoded); } catch(e){ return ''; }
  },
  selected_domain:()=>JSON.parse(localStorage.getItem('selected_domain')),
  domain:()=>JSON.parse(localStorage.getItem('selected_domain')) && JSON.parse(localStorage.getItem('selected_domain')).domain ,
  domain_provider:()=>JSON.parse(localStorage.getItem('selected_domain')) && JSON.parse(localStorage.getItem('selected_domain')).domain_provider ,
  timezone:()=>JSON.parse(localStorage.getItem('selected_domain')) && JSON.parse(localStorage.getItem('selected_domain')).timezone ,
  domain_verified:()=>JSON.parse(localStorage.getItem('selected_domain')) && JSON.parse(localStorage.getItem('selected_domain')).verified || false,
  hybrid_o365_verified:()=>JSON.parse(localStorage.getItem('selected_domain')) && JSON.parse(localStorage.getItem('selected_domain')).hybrid_o365_verified || false,
  hybrid_exchange_verified:()=>JSON.parse(localStorage.getItem('selected_domain')) && JSON.parse(localStorage.getItem('selected_domain')).hybrid_exchange_verified || false,
  company_id:()=>JSON.parse(localStorage.getItem('selected_domain')) && JSON.parse(localStorage.getItem('selected_domain')).company_id,
  initialURL:()=>{
   
    const domain_provider = JSON.parse(localStorage.getItem('selected_domain')) && JSON.parse(localStorage.getItem('selected_domain')).domain_provider;
    if(domain_provider == 1) {
     return 'gsuite/';
    } else if(domain_provider == 2) {
        return  'office/';
    
    } else if(domain_provider == 4) {
        return 'exchange/';
    } else if(domain_provider == 5) {
        return  'hybrid/';
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js